/**
 * Extracts the domain from a given URL.
 *
 * @param {string} url - The URL from which to extract the domain.
 * @returns {string} The domain extracted from the URL.
 */
export const extractDomain = (url: string): string => {
  if (!url) return '';
  try {
    const { hostname } = new URL(url);
    return hostname.startsWith('www.') ? hostname.slice(4) : hostname;
  } catch (e) {
    return '';
  }
};
